(function () {
  class CompleteTheLook extends HTMLElement {
    constructor() {
      super();
      this.miniCart = document.querySelector('mini-cart');
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.querySelectorAll('[data-complete-the-look-item]').forEach((item) => this.initItem(item));

      // Close any open dropdown when clicking outside of it.
      this.onDocumentClick = (event) => {
        this.querySelectorAll('[data-complete-the-look-custom-select][data-open="true"]').forEach((wrapper) => {
          if (!wrapper.contains(event.target)) {
            this.closeDropdown(wrapper);
          }
        });
      };
      document.addEventListener('click', this.onDocumentClick);

      // Close an open dropdown on Escape.
      this.onDocumentKeydown = (event) => {
        if (event.key !== 'Escape') return;
        this.querySelectorAll('[data-complete-the-look-custom-select][data-open="true"]').forEach((wrapper) => {
          this.closeDropdown(wrapper);
        });
      };
      document.addEventListener('keydown', this.onDocumentKeydown);

      if (typeof subscribe === 'function') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.syncWithCart();
        });
      }

      this.onCartUpdated = () => this.syncWithCart();
      document.addEventListener('cart:updated', this.onCartUpdated);

      this.syncWithCart();
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }

      if (this.onCartUpdated) {
        document.removeEventListener('cart:updated', this.onCartUpdated);
      }

      if (this.onDocumentClick) {
        document.removeEventListener('click', this.onDocumentClick);
      }

      if (this.onDocumentKeydown) {
        document.removeEventListener('keydown', this.onDocumentKeydown);
      }
    }

    initItem(item) {
      const variantsScript = item.querySelector('[data-complete-the-look-variants]');
      const mediaScript = item.querySelector('[data-complete-the-look-media]');
      const addButton = item.querySelector('[data-complete-the-look-add]');
      const dropdowns = item.querySelectorAll('[data-complete-the-look-custom-select]');

      if (!variantsScript || !addButton) return;

      try {
        item.variants = JSON.parse(variantsScript.textContent || '[]');
      } catch (e) {
        item.variants = [];
      }

      try {
        item.mediaMap = JSON.parse(mediaScript?.textContent || '[]').reduce((map, entry) => {
          map[entry.id] = entry.featured_image;
          return map;
        }, {});
      } catch (e) {
        item.mediaMap = {};
      }

      item.selectedOptions = {};

      dropdowns.forEach((wrapper) => {
        const group = wrapper.closest('[data-complete-the-look-option-group]');
        const optionIndex = parseInt(group?.dataset.optionIndex, 10);
        if (Number.isNaN(optionIndex)) return;

        const toggle = wrapper.querySelector('[data-complete-the-look-select-toggle]');
        const label = toggle?.querySelector('[data-complete-the-look-select-label]');
        const options = wrapper.querySelectorAll('[data-complete-the-look-select-option]');

        const selectedOption =
          wrapper.querySelector('[data-complete-the-look-select-option][aria-selected="true"]') || options[0];

        if (selectedOption) {
          item.selectedOptions[optionIndex] = selectedOption.dataset.value;
        }

        toggle?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggleDropdown(wrapper);
        });

        options.forEach((option) => {
          option.addEventListener('click', (event) => {
            event.stopPropagation();
            if (option.getAttribute('aria-disabled') === 'true') return;

            options.forEach((opt) => opt.setAttribute('aria-selected', 'false'));
            option.setAttribute('aria-selected', 'true');

            if (label) label.textContent = option.textContent.trim();

            item.selectedOptions[optionIndex] = option.dataset.value;

            this.closeDropdown(wrapper);
            this.updateItemVariant(item);
          });
        });
      });

      this.updateItemVariant(item);

      addButton.addEventListener('click', () => this.addToCart(item, addButton));
    }

    toggleDropdown(wrapper) {
      const isOpen = wrapper.dataset.open === 'true';

      // Only one dropdown open at a time.
      this.querySelectorAll('[data-complete-the-look-custom-select][data-open="true"]').forEach((openWrapper) => {
        if (openWrapper !== wrapper) this.closeDropdown(openWrapper);
      });

      if (isOpen) {
        this.closeDropdown(wrapper);
      } else {
        this.openDropdown(wrapper);
      }
    }

    openDropdown(wrapper) {
      const toggle = wrapper.querySelector('[data-complete-the-look-select-toggle]');
      const list = wrapper.querySelector('[data-complete-the-look-select-list]');
      wrapper.dataset.open = 'true';
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (list) list.hidden = false;
    }

    closeDropdown(wrapper) {
      const toggle = wrapper.querySelector('[data-complete-the-look-select-toggle]');
      const list = wrapper.querySelector('[data-complete-the-look-select-list]');
      wrapper.dataset.open = 'false';
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (list) list.hidden = true;
    }

    getMatchedVariant(item) {
      const optionCount = Object.keys(item.selectedOptions).length;

      if (optionCount === 0) {
        return item.variants.find((variant) => variant.available) || item.variants[0] || null;
      }

      return (
        item.variants.find((variant) => {
          return variant.options.every((value, index) => item.selectedOptions[index] === value);
        }) || null
      );
    }

    updateItemVariant(item) {
      const addButton = item.querySelector('[data-complete-the-look-add]');
      const priceEl = item.querySelector('[data-complete-the-look-price]');
      const imageEl = item.querySelector('[data-complete-the-look-image]');
      const wishlistBtn = item.querySelector('.complete-the-look__wishlist');
      const dropdowns = item.querySelectorAll('[data-complete-the-look-custom-select]');
      const matchedVariant = this.getMatchedVariant(item);

      dropdowns.forEach((wrapper) => {
        const group = wrapper.closest('[data-complete-the-look-option-group]');
        const optionIndex = parseInt(group?.dataset.optionIndex, 10);
        if (Number.isNaN(optionIndex)) return;

        const options = wrapper.querySelectorAll('[data-complete-the-look-select-option]');

        options.forEach((option) => {
          const value = option.dataset.value;
          const isAvailable = item.variants.some((variant) => {
            if (variant.options[optionIndex] !== value) return false;
            return (
              variant.options.every((variantValue, index) => {
                if (index === optionIndex) return true;
                if (item.selectedOptions[index] === undefined) return true;
                return variantValue === item.selectedOptions[index];
              }) && variant.available
            );
          });

          // This is what actually renders the strikethrough on sold-out
          // sizes now — a real class toggle instead of an <s> tag that
          // never rendered inside a native <option>.
          option.classList.toggle('complete-the-look__select-option--soldout', !isAvailable);

          if (isAvailable) {
            option.removeAttribute('aria-disabled');
          } else {
            option.setAttribute('aria-disabled', 'true');
          }
        });
      });

      if (!matchedVariant) {
        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
        addButton.dataset.variantId = '';
        return;
      }

      addButton.dataset.variantId = matchedVariant.id;

      if (wishlistBtn) {
        wishlistBtn.dataset.variantId = matchedVariant.id;
      }

      if (priceEl) {
        this.updatePrice(priceEl, matchedVariant);
      }

      if (imageEl && item.mediaMap[matchedVariant.id]) {
        imageEl.src = item.mediaMap[matchedVariant.id];
      }

      if (matchedVariant.available) {
        addButton.disabled = false;
        addButton.removeAttribute('aria-disabled');
        if (!addButton.classList.contains('loading')) {
          addButton.textContent = addButton.dataset.defaultLabel || 'Add to Cart';
        }
      } else {
        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
        addButton.textContent = window.theme?.strings?.soldOut || 'Sold out';
      }
    }

    updatePrice(priceEl, variant) {
      const price = priceEl.querySelector('.price');
      const priceRegular = priceEl.querySelector('.price__regular .price-item--regular');
      const priceSaleItem = priceEl.querySelector('.price__sale .price-item--sale');
      const priceCompareItem = priceEl.querySelector('.price__sale .price-item--regular');

      if (!price || !priceRegular) return;

      const formatMoney = (cents) => {
        if (window.theme?.Currency?.formatMoney && window.theme?.shopSettings?.moneyFormat) {
          return window.theme.Currency.formatMoney(cents, window.theme.shopSettings.moneyFormat);
        }

        if (window.Shopify?.formatMoney) {
          return window.Shopify.formatMoney(cents, window.theme?.moneyFormat);
        }

        return (cents / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD',
        });
      };

      const moneyHtml = (cents) =>
        `<price-money><bdi>${formatMoney(cents)}</bdi></price-money>`;

      priceRegular.innerHTML = moneyHtml(variant.price);

      if (priceSaleItem) {
        priceSaleItem.innerHTML = moneyHtml(variant.price);
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        price.classList.add('price--on-sale');
        price.classList.remove('price--sold-out');
        if (priceCompareItem) {
          priceCompareItem.innerHTML = moneyHtml(variant.compare_at_price);
        }
      } else {
        price.classList.remove('price--on-sale');
        if (variant.available) {
          price.classList.remove('price--sold-out');
        } else {
          price.classList.add('price--sold-out');
        }
      }
    }

    addToCart(item, button) {
      const variantId = button.dataset.variantId;
      if (!variantId || button.classList.contains('loading')) return;

      if (document.body.classList.contains('template-cart') || !window.theme?.shopSettings?.cartDrawer) {
        window.Shopify?.postLink(window.theme.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1,
          },
        });
        this.hideItem(item);
        return;
      }

      if (!button.dataset.defaultLabel) {
        button.dataset.defaultLabel = button.textContent.trim();
      }

      button.disabled = true;
      button.classList.add('loading');

      const sections = this.miniCart
        ? this.miniCart.getSectionsToRender().map((section) => section.id)
        : [];

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections,
        sections_url: window.location.pathname,
      });

      fetch(`${window.theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status) {
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'complete-the-look',
                productVariantId: variantId,
                errors: parsedState.errors || parsedState.description,
                message: parsedState.message,
              });
            }

            document.dispatchEvent(
              new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description,
                },
              })
            );
            return;
          }

          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'complete-the-look',
              productVariantId: variantId,
            });
          }

          if (this.miniCart) {
            this.miniCart.renderContents(parsedState);
          }

          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState,
              },
            })
          );

          this.hideItem(item);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          button.classList.remove('loading');
          if (button.isConnected) {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
          }
        });
    }

    hideItem(item, animate = true) {
      if (item.classList.contains('complete-the-look__item--hidden')) return;

      if (animate) {
        item.classList.add('complete-the-look__item--removing');

        window.setTimeout(() => {
          item.classList.remove('complete-the-look__item--removing');
          item.classList.add('complete-the-look__item--hidden');
          this.checkEmpty();
        }, 250);
        return;
      }

      item.classList.add('complete-the-look__item--hidden');
      this.checkEmpty();
    }

    showItem(item) {
      item.classList.remove('complete-the-look__item--hidden', 'complete-the-look__item--removing');
      this.classList.remove('complete-the-look--hidden');
    }

    checkEmpty() {
      const visibleItems = this.querySelectorAll(
        '[data-complete-the-look-item]:not(.complete-the-look__item--hidden)'
      );

      if (visibleItems.length === 0) {
        this.classList.add('complete-the-look--hidden');
      } else {
        this.classList.remove('complete-the-look--hidden');
      }
    }

    syncWithCart() {
      if (!window.theme?.routes?.cart_url) return;

      fetch(`${window.theme.routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => {
          const productIdsInCart = new Set(cart.items.map((lineItem) => lineItem.product_id));

          this.querySelectorAll('[data-complete-the-look-item]').forEach((item) => {
            const productId = parseInt(item.dataset.productId, 10);

            if (productIdsInCart.has(productId)) {
              this.hideItem(item, false);
            } else {
              this.showItem(item);
            }
          });

          this.checkEmpty();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('complete-the-look', CompleteTheLook);
})();